<template>
  <div class="app-shell">
    <div class="app-content">
      <AppLayout>
        <router-view/>
      </AppLayout>
    </div>

<!--    <footer class="site-footer">-->
<!--      <div class="container">-->
<!--        <div class="site-footer__grid">-->
<!--          <div class="site-footer__block">-->
<!--            <div class="site-footer__title">ЗАВБАС</div>-->
<!--            <div class="site-footer__text">-->
<!--              Организация туров в горнолыжные центры-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="site-footer__block">-->
<!--            <div class="site-footer__title">Контакты</div>-->
<!--            <div class="site-footer__text">-->
<!--              <div>-->
<!--                Адрес:-->
<!--                <a-->
<!--                    href="https://go.2gis.com/ICaVP"-->
<!--                    target="_blank"-->
<!--                    rel="noopener noreferrer"-->
<!--                    title="Открыть в 2ГИС"-->
<!--                >-->
<!--                  ул. Тимирязева 41, цокольный этаж-->
<!--                </a>-->
<!--              </div>-->
<!--              <div>-->
<!--                Телефон:-->
<!--                <a href="tel:+73517507287">+7 (351) 750-72-87</a>-->
<!--              </div>-->

<!--              <div>-->
<!--                Email:-->
<!--                <a href="mailto:zavbus@mail.ru">zavbus@mail.ru</a>-->
<!--              </div>-->

<!--              <div>-->
<!--                VK:-->
<!--                <a href="https://vk.ru/zavbus/" target="_blank" rel="noopener noreferrer">-->
<!--                  vk.ru/zavbus-->
<!--                </a>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--          <div class="site-footer__block">-->
<!--            <div class="site-footer__title">Навигация</div>-->
<!--            <div class="site-footer__text">-->
<!--              <div><a href="/trips">Выезды</a></div>-->
<!--              <div><a href="/services">Прокат и Сервис</a></div>-->
<!--              <div><a href="/contacts">Контакты</a></div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="site-footer__block">-->
<!--            <div class="site-footer__title">Юридические реквизиты</div>-->
<!--            <div class="site-footer__text">-->
<!--              <div>ИП Самигуллин Евгений Марселевич</div>-->
<!--              <div>454092, г. Челябинск, ул. Тимирязева 41</div>-->
<!--              <div>ИНН 745208585592</div>-->
<!--              <div>ОГРНИП 317745600168025</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </footer>-->
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import AppLayout from "@/layouts/AppLayout.vue"

export default defineComponent({
  name: 'app',
  components: {
    AppLayout
  }
});
</script>

<style>
html,
body,
#app {
  min-height: 100%;
}

body {
  font-family: "Raleway", sans-serif;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1 0 auto;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-green {
  color: #18d26e;
}

.text-red {
  color: #d31515;
}

/* Возвращаем секции в нормальный поток документа */
section,
.section-show,
#trip,
.trip {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  width: 100%;
}

/* Чтобы контент не залезал под шапку */
.section-show {
  padding-top: 110px;
}

/* Footer */
.site-footer {
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  width: 100%;
  margin-top: 40px;
  padding: 40px 0;
  background: rgba(0, 0, 0, 0.88);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  clear: both;
}

.site-footer__grid {
  display: grid;
  grid-template-columns: 1.25fr 1.5fr 0.9fr 1.3fr;
  gap: 30px;
}

.site-footer__block {
  color: #cfcfcf;
}

.site-footer__title {
  color: #18d26e;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.site-footer__text {
  line-height: 1.8;
  font-size: 15px;
}

.site-footer a {
  color: #ffffff;
  text-decoration: none;
  border-bottom: 1px solid rgba(24, 210, 110, 0.35);
  transition: color 0.2s ease, border-color 0.2s ease;
}

.site-footer a:hover {
  color: #18d26e;
  border-bottom-color: #18d26e;
}

@media (max-width: 768px) {
  .section-show {
    padding-top: 90px;
  }

  .site-footer {
    padding: 30px 0;
  }

  .site-footer__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
